export default {
  // Tab names
  'tab.main': 'Hauptseite',
  'tab.producers': 'Produzenten',
  'tab.achievements': 'Erfolge',
  'tab.prestige': 'Prestige',
  'tab.settings': 'Einstellungen',

  // Header
  'header.bps': '/Sek',
  'header.stage': 'Stufe',
  'header.tap': 'TAP!',

  // Combo
  'combo.nice': 'Nice!',
  'combo.great': 'Great!',
  'combo.amazing': 'Amazing!',
  'combo.incredible': 'INCREDIBLE!',
  'combo.legendary': 'LEGENDARY!',
  'combo.label': 'Kombo',

  // Critical
  'crit.label': 'CRITICAL!',

  // Producers
  'producer.P1': 'Samen',
  'producer.P2': 'Keim',
  'producer.P3': 'Setzling',
  'producer.P4': 'Kaffeebaum',
  'producer.P5': 'Kleine Farm',
  'producer.P6': 'Grosse Farm',
  'producer.P7': 'Roesterei',
  'producer.P8': 'Kaffeefabrik',
  'producer.P9': 'Export-Hub',
  'producer.P10': 'Franchise',
  'producer.P11': 'Kaffee-Imperium',
  'producer.P12': 'Kaffee-Planet',

  // Tap upgrades
  'upgrade.T1': 'Flinke Finger',
  'upgrade.T2': 'Handschuhe',
  'upgrade.T3': 'Werkzeuge',
  'upgrade.T4': 'Maschinen',
  'upgrade.T5': 'Roboter',
  'upgrade.T6': 'Nanotechnologie',
  'upgrade.T7': 'Quantenernte',
  'upgrade.T8': 'Zeitkruemmung',

  // Prestige upgrades
  'prestige.G1': 'Goldener Samen',
  'prestige.G1.desc': 'BPS +1 Basis',
  'prestige.G2': 'Fruchtbarer Boden',
  'prestige.G2.desc': 'Tipp-Kraft x1.5',
  'prestige.G3': 'Anfaengerrabatt',
  'prestige.G3.desc': 'P1~P3 Kosten -50%',
  'prestige.G4': 'Nachtliches Wachstum',
  'prestige.G4.desc': 'Offline-Effizienz +20%',
  'prestige.G5': 'Schnellanbau',
  'prestige.G5.desc': 'Gesamt-BPS x2',
  'prestige.G6': 'Glueckshaende',
  'prestige.G6.desc': 'Krit. Chance +3%',
  'prestige.G7': 'Meister-Barista',
  'prestige.G7.desc': 'Tipp-Kraft x3',
  'prestige.G8': 'Grosshandelsrabatt',
  'prestige.G8.desc': 'Alle Kosten -20%',
  'prestige.G9': 'Schnellstart',
  'prestige.G9.desc': 'Start mit 10 P1~P3',
  'prestige.G10': 'Premium-Mischung',
  'prestige.G10.desc': 'Gesamt-BPS x3',
  'prestige.G11': 'Bohne der Zeit',
  'prestige.G11.desc': 'Offline-Effizienz 100%',
  'prestige.G12': 'Krone des Kaffeekoenigs',
  'prestige.G12.desc': 'Gesamtproduktion x2',
  'prestige.G13': 'Goldbohnenbaum',
  'prestige.G13.desc': 'Goldbohnen-Gewinn +20%',
  'prestige.G14': 'Zeitreise',
  'prestige.G14.desc': 'Start bei Stufe 5',
  'prestige.G15': 'Unendliche Bohnen',
  'prestige.G15.desc': 'Gesamtproduktion x10',
  'prestige.G16': 'Kaffee-Urknall',
  'prestige.G16.desc': 'Goldbohnen-Gewinn x2',

  // Star upgrades
  'star.S1': 'Startkapital',
  'star.S1.desc': '1M Bohnen beim Start',
  'star.S2': 'Ewiges Gold',
  'star.S2.desc': 'Goldbohnen-Gewinn x2 permanent',
  'star.S3': 'Segen der Sterne',
  'star.S3.desc': 'Gesamt-BPS x5 permanent',
  'star.S4': 'Auto-Tipp',
  'star.S4.desc': '1 Auto-Tipp pro Sekunde',
  'star.S5': 'Kombo-Meister',
  'star.S5.desc': 'Kombo-Dauer 3 Sek',
  'star.S6': 'Toedlicher Schlag',
  'star.S6.desc': 'Krit. Multiplikator x2',
  'star.S7': 'Kosmische Kraft',
  'star.S7.desc': 'Gesamtproduktion x10 permanent',
  'star.S8': 'Transzendenter Stern',
  'star.S8.desc': 'Aufstiegsbonus x3',

  // Varieties
  'variety.V1': 'Arabica',
  'variety.V2': 'Robusta',
  'variety.V3': 'Liberica',
  'variety.V4': 'Excelsa',
  'variety.V5': 'Geisha',
  'variety.V6': 'Kopi Luwak',
  'variety.V7': 'Blue Mountain',
  'variety.V8': 'Kona',
  'variety.V9': 'Yirgacheffe',
  'variety.V10': 'Peaberry',
  'variety.V11': 'Maragogipe',
  'variety.V12': 'St. Helena',

  // Stages
  'stage.1': 'Omas Garten',
  'stage.2': 'Kleiner Hof',
  'stage.3': 'Kaffeefarm',
  'stage.4': 'Roesterei',
  'stage.5': 'Kaffeefabrik',
  'stage.6': 'Globale Kette',
  'stage.7': 'Kaffee-Koenigreich',

  // Roasting
  'roast.perfect': 'Perfekte Roestung!',
  'roast.dark': 'Dunkle Roestung',
  'roast.medium': 'Mittlere Roestung',
  'roast.light': 'Helle Roestung',
  'roast.burnt': 'Verbrannt...',
  'roast.raw': 'Zu roh',
  'roast.tap': 'Tippe zum Stoppen!',
  'roast.reward': 'Belohnung',
  'roast.double': 'Werbung fuer 2x!',
  'roast.collect': 'Einsammeln',

  // Achievements
  'ach.tap1': 'Erste Schritte', 'ach.tap1.desc': '100-mal tippen',
  'ach.tap2': 'Fleissige Haende', 'ach.tap2.desc': '1.000-mal tippen',
  'ach.tap3': 'Tipp-Meister', 'ach.tap3.desc': '10.000-mal tippen',
  'ach.tap4': 'Legendaerer Finger', 'ach.tap4.desc': '100.000-mal tippen',
  'ach.tap5': 'Gott des Tippens', 'ach.tap5.desc': '1.000.000-mal tippen',
  'ach.tap6': 'Schnelle Haende', 'ach.tap6.desc': '5 Tipps pro Sekunde',
  'ach.tap7': 'Blitzhaende', 'ach.tap7.desc': '10 Tipps pro Sekunde',
  'ach.tap8': 'Goettliche Haende', 'ach.tap8.desc': '15 Tipps pro Sekunde',
  'ach.tap9': 'Kombo-Manie', 'ach.tap9.desc': '20er Kombo erreichen',
  'ach.tap10': 'Legendaere Kombo', 'ach.tap10.desc': '50er Kombo erreichen',

  'ach.prod1': 'Erste Ernte', 'ach.prod1.desc': '1K Bohnen geerntet',
  'ach.prod2': 'Kleiner Erfolg', 'ach.prod2.desc': '100K Bohnen geerntet',
  'ach.prod3': 'Wachsende Farm', 'ach.prod3.desc': '10M Bohnen geerntet',
  'ach.prod4': 'Kaffee-Mogul', 'ach.prod4.desc': '1B Bohnen geerntet',
  'ach.prod5': 'Kaffee-Kaiser', 'ach.prod5.desc': '1T Bohnen geerntet',
  'ach.prod6': 'Automatisierung gestartet', 'ach.prod6.desc': '100 BPS erreichen',
  'ach.prod7': 'Fabrik laeuft', 'ach.prod7.desc': '10K BPS erreichen',
  'ach.prod8': 'Industrielle Revolution', 'ach.prod8.desc': '1M BPS erreichen',
  'ach.prod9': 'Globale Produktion', 'ach.prod9.desc': '100M BPS erreichen',
  'ach.prod10': 'Kosmische Produktion', 'ach.prod10.desc': '10B BPS erreichen',

  'ach.bld1': 'Anfaenger-Bauer', 'ach.bld1.desc': 'Je 1 von P1~P4 besitzen',
  'ach.bld2': 'Fortgeschrittener Bauer', 'ach.bld2.desc': 'Je 1 von P1~P8 besitzen',
  'ach.bld3': 'Meister-Bauer', 'ach.bld3.desc': 'Alle Produzenten besitzen',
  'ach.bld4': 'Fokussierte Investition', 'ach.bld4.desc': '10 einer Art besitzen',
  'ach.bld5': 'Grosseinkauf', 'ach.bld5.desc': '25 einer Art besitzen',
  'ach.bld6': 'Sammler', 'ach.bld6.desc': '50 einer Art besitzen',
  'ach.bld7': 'Monopolist', 'ach.bld7.desc': '100 einer Art besitzen',
  'ach.bld8': 'Geschaeftserweiterung', 'ach.bld8.desc': '100 Produzenten gesamt',
  'ach.bld9': 'Unternehmensimperium', 'ach.bld9.desc': '500 Produzenten gesamt',
  'ach.bld10': 'Weltherrschaft', 'ach.bld10.desc': '1000 Produzenten gesamt',

  'ach.pres1': 'Erste Wiedergeburt', 'ach.pres1.desc': '1-mal Prestige',
  'ach.pres2': 'Geschmack der Wiederholung', 'ach.pres2.desc': '3-mal Prestige',
  'ach.pres3': 'Prestige-Meister', 'ach.pres3.desc': '5-mal Prestige',
  'ach.pres4': 'Endloser Kreislauf', 'ach.pres4.desc': '10-mal Prestige',
  'ach.pres5': 'Ewiger Ring', 'ach.pres5.desc': '20-mal Prestige',
  'ach.pres6': 'Reinkarnations-Experte', 'ach.pres6.desc': '50-mal Prestige',
  'ach.pres7': 'Goldene Ernte', 'ach.pres7.desc': '10 Goldbohnen auf einmal',
  'ach.pres8': 'Goldener Sturm', 'ach.pres8.desc': '100 Goldbohnen auf einmal',
  'ach.pres9': 'Speedrunner', 'ach.pres9.desc': 'Prestige in 30 Min',
  'ach.pres10': 'Blitz-Wiedergeburt', 'ach.pres10.desc': 'Prestige in 15 Min',

  'ach.spec1': 'Kirschenjaeger', 'ach.spec1.desc': 'Goldkirsche 1-mal tippen',
  'ach.spec2': 'Kirschen-Manie', 'ach.spec2.desc': 'Goldkirsche 10-mal tippen',
  'ach.spec3': 'Kirschen-Meister', 'ach.spec3.desc': 'Goldkirsche 50-mal tippen',
  'ach.spec4': 'Roest-Anfaenger', 'ach.spec4.desc': 'Perfekte Roestung 1-mal',
  'ach.spec5': 'Roest-Experte', 'ach.spec5.desc': 'Perfekte Roestung 10-mal',
  'ach.spec6': 'Sorten-Sammler', 'ach.spec6.desc': '5 Sorten gesammelt',
  'ach.spec7': 'Kaffee-Doktor', 'ach.spec7.desc': 'Alle 12 Sorten gesammelt',
  'ach.spec8': 'Fleissiger Bauer', 'ach.spec8.desc': '1 Stunde Spielzeit gesamt',
  'ach.spec9': 'Kaffee-Suechtig', 'ach.spec9.desc': '24 Stunden Spielzeit gesamt',
  'ach.spec10': '7 Tage am Stueck', 'ach.spec10.desc': '7 Tage hintereinander',

  'ach.mile1': 'Kaffeefarmbesitzer', 'ach.mile1.desc': 'Stufe 3 erreichen',
  'ach.mile2': 'Kaffee-Unternehmer', 'ach.mile2.desc': 'Stufe 5 erreichen',
  'ach.mile3': 'Kaffee-Koenig', 'ach.mile3.desc': 'Stufe 7 erreichen',
  'ach.mile4': 'Transzendent', 'ach.mile4.desc': 'Erster Sternenaufstieg',
  'ach.mile5': 'Perfektionist', 'ach.mile5.desc': '50 Erfolge freigeschaltet',

  // Achievement categories
  'ach.cat.tapping': 'Tippen',
  'ach.cat.production': 'Produktion',
  'ach.cat.producers': 'Produzenten',
  'ach.cat.prestige': 'Prestige',
  'ach.cat.special': 'Spezial',
  'ach.cat.milestone': 'Meilensteine',

  // Prestige panel
  'prestige.title': 'Roest-Wiedergeburt',
  'prestige.desc': 'Wiedergeboren werden fuer Goldbohnen und staerker starten!',
  'prestige.goldenBeans': 'Goldbohnen',
  'prestige.expected': 'Erwarteter Gewinn',
  'prestige.rebirth': 'Wiedergeburt',
  'prestige.upgrades': 'Prestige-Upgrades',
  'prestige.locked': 'Freischaltung bei Stufe 7',
  'prestige.adBonus': 'Werbung fuer +30%',

  // Ascension panel
  'ascend.title': 'Sternenaufstieg',
  'ascend.desc': 'Aufsteigen fuer Sternenstaub und alles transzendieren!',
  'ascend.starDust': 'Sternenstaub',
  'ascend.expected': 'Erwarteter Gewinn',
  'ascend.ascend': 'Aufsteigen',
  'ascend.upgrades': 'Stern-Upgrades',
  'ascend.locked': '10 Wiedergeburten + 100 Goldbohnen noetig',

  // Settings
  'settings.bgm': 'Hintergrundmusik',
  'settings.sfx': 'Soundeffekte',
  'settings.vibration': 'Vibration',
  'settings.language': 'Sprache',
  'settings.reset': 'Daten zuruecksetzen',
  'settings.resetConfirm': 'Wirklich alle Daten loeschen?',
  'settings.credits': 'Mitwirkende',
  'settings.version': 'Version',

  // Boost buttons
  'boost.tap': 'Tipp-Boost',
  'boost.bps': 'Produktions-Boost',

  // Offline
  'offline.title': 'Willkommen zurueck!',
  'offline.earned': 'Offline-Einnahmen',
  'offline.time': 'Abwesenheit',
  'offline.collect': 'Einsammeln',
  'offline.adX3': 'Werbung fuer x3',

  // General
  'buy': 'Kaufen',
  'max': 'Max',
  'level': 'Lv.',
  'locked': 'Gesperrt',
  'owned': 'Besitz',
  'on': 'AN',
  'off': 'AUS',
} as const;
